module.exports = __webpack_public_path__ + "img/slide-1.4002f15e.jpg";